const data = [
  {
    id: 2,
    id_klienta: 9,
    nazwa: "Note title",
    rok: 2020,
  },
  {
    id: 3,
    id_klienta: 9,
    nazwa: "Random title",
    rok: 2020,
  },
  {
    id: 4,
    id_klienta: 9,
    nazwa: "Dokumenty",
    rok: 2020,
  },
  {
    id: 5,
    id_klienta: 10,
    nazwa: "Zakupy",
    rok: 2019,
  },
  {
    id: 6,
    id_klienta: 11,
    nazwa: "Rower",
    rok: 2017,
  },
  {
    id: 7,
    id_klienta: 9,
    nazwa: "Faktury 9",
    rok: 2019,
  },
  {
    id: 8,
    id_klienta: 13,
    nazwa: "Faktury",
    rok: 2016,
  },
  {
    id: 35,
    id_klienta: 9,
    nazwa: "Segregator 1",
    rok: 2020,
  },
  {
    id: 36,
    id_klienta: 9,
    nazwa: "Notaka 2",
    rok: 2020,
  },
  {
    id: 37,
    id_klienta: 9,
    nazwa: "Mat. Budowlane",
    rok: 2020,
  },
  {
    id: 38,
    id_klienta: 9,
    nazwa: "Maseczki",
    rok: 2020,
  },
  {
    id: 39,
    id_klienta: 9,
    nazwa: "Zakupy",
    rok: 2020,
  },
  {
    id: 40,
    id_klienta: 9,
    nazwa: "Mat. Biurowe",
    rok: 2020,
  },
  {
    id: 41,
    id_klienta: 9,
    nazwa: "React",
    rok: 2020,
  },
  {
    id: 42,
    id_klienta: 9,
    nazwa: "Mat. Budowlane 2021",
    rok: 2021,
  },
  {
    id: 43,
    id_klienta: 9,
    nazwa: "test 2019",
    rok: 2019,
  },
  {
    id: 44,
    id_klienta: 9,
    nazwa: "Segregator 11",
    rok: 2021,
  },
  {
    id: 55,
    id_klienta: 9,
    nazwa: "Testowanie segregatora",
    rok: 2022,
  },
  {
    id: 59,
    id_klienta: 9,
    nazwa: "test",
    rok: 2021,
  },
  {
    id: 60,
    id_klienta: 9,
    nazwa: "test",
    rok: 2021,
  },
  {
    id: 61,
    id_klienta: 9,
    nazwa: "Test",
    rok: 2021,
  },
  {
    id: 63,
    id_klienta: 9,
    nazwa: "tmp123",
    rok: 2021,
  },
  {
    id: 64,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 65,
    id_klienta: 9,
    nazwa: "Sample Data 2",
    rok: 2002,
  },
  {
    id: 66,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 67,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 68,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 69,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 70,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 71,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 72,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 73,
    id_klienta: 9,
    nazwa: "Sample Data 2",
    rok: 2002,
  },
  {
    id: 74,
    id_klienta: 9,
    nazwa: "Test 1",
    rok: 2022,
  },
  {
    id: 75,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 76,
    id_klienta: 9,
    nazwa: "Sample Data 1",
    rok: 2002,
  },
  {
    id: 77,
    id_klienta: 9,
    nazwa: "tttt",
    rok: 2022,
  },
  {
    id: 78,
    id_klienta: 9,
    nazwa: "1",
    rok: 2022,
  },
  {
    id: 79,
    id_klienta: 9,
    nazwa: "1",
    rok: 2022,
  },
  {
    id: 80,
    id_klienta: 9,
    nazwa: "22",
    rok: 2021,
  },
];

export default data;
